module.exports = __webpack_public_path__ + "media/static/icons/icon-arrow-up-ae98ce1f3421a1f0ebfa247aa51721c4.svg";